<template>
    <section>
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :customHandleSearch="customHandleSearch"></toolbar>
  
      <!--列表-->
      <el-table
        ref="multipleTable"
        :data="sysDicts"
        tooltip-effect="dark"
        border
        v-loading="listLoading"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        @row-click="selectCurrentRow"
        class="custom-tbl"
      >
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column type="index" label="序号" width="80"> </el-table-column>
        <el-table-column
          prop="DictCode"
          label="字典编码"
          width="300"
          sortable
        >
        </el-table-column>
        <el-table-column prop="DictName" label="字典名" width="" sortable>
        </el-table-column>
        <el-table-column prop="ItemValue" label="字典项值" width="" sortable>
        </el-table-column>
        <el-table-column prop="ItemText" label="字典项文本" width="" sortable>
        </el-table-column>
        <el-table-column
          prop="CreateTime"
          label="创建时间"
          :formatter="formatCreateTime"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column prop="CreateBy" label="创建者" width="" sortable>
        </el-table-column>
        <!-- <el-table-column prop="IsEnable" label="状态" width="" sortable>
            <template slot-scope="scope">
              <el-tag :type="scope.row.IsEnable ? 'success' : 'danger'" disable-transitions>{{ scope.row.IsEnable ? "正常" : "禁用" }}
              </el-tag>
            </template>
          </el-table-column> -->
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" size="small" @click="handleDel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 上下页标 -->
      <el-pagination
        class="toolbar"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
  
      <!-- 新增 -->
      <el-dialog
        title="新增"
        :visible.sync="addFormVisible"
        v-model="addFormVisible"
        :close-on-click-modal="false"
      >
        <el-form
          :model="addForm"
          label-width="120px"
          :rules="addFormRules"
          ref="addForm"
        >
          <el-form-item label="字典编码" prop="DictCode">
            <el-input
              v-model="addForm.DictCode"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="字典名" prop="DictName">
            <el-input v-model="addForm.DictName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字典项文本" prop="ItemText">
            <el-input v-model="addForm.ItemText" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字典项值" prop="ItemValue">
            <el-input type="number" v-model="addForm.ItemValue" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="Remark">
            <el-input v-model="addForm.Remark" auto-complete="off"></el-input>
          </el-form-item>
          <!-- <el-form-item label="状态" prop="IsEnable">
              <el-select v-model="addForm.IsEnable" placeholder="请选择状态">
                <el-option label="激活" value="true"></el-option>
                <el-option label="禁用" value="false"></el-option>
              </el-select>
            </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="addSubmit"
            :loading="addLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
  
      <!--编辑界面-->
      <el-dialog
        title="编辑"
        :visible.sync="editFormVisible"
        v-model="editFormVisible"
        :close-on-click-modal="false"
      >
        <el-form
          :model="editForm"
          label-width="120px"
          :rules="addFormRules"
          ref="editForm"
        >
        <el-form-item label="字典编码" prop="DictCode">
            <el-input
              v-model="editForm.DictCode"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="字典名" prop="DictName">
            <el-input v-model="editForm.DictName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字典项文本" prop="ItemText">
            <el-input v-model="editForm.ItemText" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字典项值" prop="ItemValue">
            <el-input type="number" v-model="editForm.ItemValue" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="Remark">
            <el-input v-model="editForm.Remark" auto-complete="off"></el-input>
          </el-form-item>
          <!-- <el-form-item label="状态" prop="IsEnable">
              <el-select v-model="editForm.IsEnable" placeholder="请选择状态">
                <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="editSubmit"
            :loading="editLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </section>
  </template>
    
    <script>
  import util from "../../../util/date";
  import {
    GetSysDictLs,
    DelSysDic,
    AddSysDict,
  } from "../../api/SysDictionary/SysDictionary";
  import { getButtonList } from "../../promissionRouter";
  import Toolbar from "../../components/Toolbar";
  
  export default {
    components: { Toolbar },
    data() {
      return {
        filters: {
          name: "",
        },
        sysDicts: [],
        total: 0,
        buttonList: [],
        currentRows: [],
        page: 1,
        pageSize: 10,
        listLoading: false,
        editFormVisible: false, //编辑界面是否显示
        editLoading: false,
        addFormVisible: false, //新增界面是否显示
        addLoading: false,
  
        addFormRules: {
          DictCode: [
            { required: true, message: "请输入字典编码", trigger: "blur" },
          ],
          DictName: [
            { required: true, message: "请输入字典名", trigger: "blur" },
          ],
          ItemText: [
            { required: true, message: "请输入字典项文本", trigger: "blur" },
          ],
          ItemValue: [
            { required: true, message: "请输入字典项值", trigger: "blur" },
          ],
        },
        //新增界面数据
        addForm: {
          DictCode: "",
          DictName: "",
          ItemText: "",
          ItemValue: 0,
          Remark: "",
        },
        //编辑界面数据
        editForm: {
          Id: 0,
          DictCode: "",
          DictName: "",
          ItemText: "",
          ItemValue: 0,
          Remark: "",
        },
      };
    },
    computed: {},
    methods: {
      handleSelectionChange(selection) {
        this.currentRows = selection;
      },
      callFunction(item) {
        this.filters = {
          name: item.search,
        };
        this[item.Func].apply(this, item);
      },
      selectCurrentRow(row) {
        const isSelected = this.currentRows.includes(row);
        if (isSelected) {
          // 如果行已经选中，则取消选中
          const index = this.currentRows.indexOf(row);
          this.currentRows.splice(index, 1);
          this.$refs.multipleTable.toggleRowSelection(row, false);
        } else {
          // 如果行未选中，则添加选中
          this.currentRows.push(row);
          this.$refs.multipleTable.toggleRowSelection(row, true);
        }
      },
      formatCreateTime: function (row, column) {
        return !row.CreateTime || row.CreateTime == ""
          ? ""
          : util.formatDate.format(
              new Date(row.CreateTime),
              "yyyy-MM-dd hh:mm:ss"
            );
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getSysDictLs();
      },
      handleSizeChange(size) {
        this.pageSize = size;
        this.page = 1; // 当更改分页大小时，重置为第一页
        this.getSysDictLs();
      },
      //获取字典信息
      getSysDictLs() {
        let para = {
          page: this.page,
          key: this.filters.name,
          pageSize: this.pageSize,
        };
        this.listLoading = true;
        GetSysDictLs(para).then((res) => {
          this.total = res.data.response.dataCount;
          this.sysDicts = res.data.response.data;
          this.listLoading = false;
          //NProgress.done();
        });
      },
      customHandleSearch(val){
      this.filters = {
        name: val,
      };
      this.getSysDictLs();
    },
      //显示新增/编辑界面
      handleAdd() {
        this.addForm = {
          DictCode: "",
          DictName: "",
          ItemText: "",
          ItemValue: 0,
          Remark: "",
        };
        this.addFormVisible = true;
      },
      //新增考核模块信息
      addSubmit: function () {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {}).then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              AddSysDict(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }
                this.addLoading = false;
                if (res.data.success) {
                  this.addLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getSysDictLs();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            });
          }
        });
      },
      //删除考核模块信息
      handleDel(row) {
        if (!row) {
          this.$message({
            message: "请选择要删除的一行数据！",
            type: "error",
          });
  
          return;
        }
        this.$confirm("确认删除该字典吗?", "提示", {
          type: "warning",
        })
          .then(() => {
            this.listLoading = true;
            //NProgress.start();
            let para = [row.Id];
            DelSysDic(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.listLoading = false;
                return;
              }
              this.listLoading = false;
              //NProgress.done();
              if (res.data.success) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
              this.getSysDictLs();
            });
          })
          .catch(() => {});
      },
      handleDels() {
        let rows = this.currentRows;
        if (!rows || rows.length === 0) {
          this.$message({
            message: "请选择要删除的数据！",
            type: "error",
          });
          return;
        }
        this.$confirm("确认删除选中的字典吗?", "提示", {
          type: "warning",
        })
          .then(() => {
            this.listLoading = true;
            //NProgress.start();
            let para = rows.map((row) => row.Id);
            DelSysDic(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.listLoading = false;
                return;
              }
              this.listLoading = false;
              //NProgress.done();
              if (res.data.success) {
                this.currentRows = [];
                this.$refs.multipleTable.clearSelection();
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
              this.getSysDictLs();
            });
          })
          .catch(() => {});
      },
      handleEdit(row) {
        if (!row) {
          this.$message({
            message: "请选择要编辑的一行数据！",
            type: "error",
          });
          return;
        }
        this.editForm = Object.assign({}, row);
        this.editFormVisible = true;
      },
      editSubmit: function () {
        //保存
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {}).then(() => {
              this.editLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.editForm);
              PutSysDict(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.getSysDictLs();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            });
          }
        });
      },
    },
  
    mounted() {
      this.getSysDictLs();
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      this.buttonList = getButtonList(this.$route.path, routers);
    },
  
    watch: {},
  };
  </script>
    
    <style scoped>
  .custom-tbl /deep/ .has-gutter .el-checkbox {
    display: none;
  }
  .custom-tbl /deep/ .el-table__header .el-checkbox {
    display: block;
  }
  </style>
    